<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <el-form
      ref="searchForm"
      slot="search-form"
      :model="searchForm"
      label-width="100px"
      inline
    >
      <el-form-item label="优惠券名称" prop="couponName">
        <el-input
          v-model="searchForm.couponName"
          placeholder="请输入关键字"
          @keypress.enter.native="search"
        ></el-input>
      </el-form-item>
      <el-form-item label="详情搜索" prop="description">
        <el-input
          v-model="searchForm.description"
          placeholder="请输入关键字"
          @keypress.enter.native="search"
        ></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li>
          <el-button
            type="primary"
            @click="$refs.operaCouponTemplateWindow.open('新建')"
            icon="el-icon-plus"
            >新建</el-button
          >
        </li>
        <li>
          <el-button @click="deleteByIdInBatch" icon="el-icon-delete"
            >删除</el-button
          >
        </li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="60px"></el-table-column>
        <el-table-column prop="id" label="" min-width="100px"></el-table-column>
        <el-table-column
          prop="couponName"
          label="优惠券名称"
          min-width="100px"
        ></el-table-column>
        <el-table-column label="折扣条件" min-width="100px">
          <template slot-scope="{ row }">
            <div>满{{ row.minAmount }}元减{{ row.discountAmount }}元</div>
          </template>
        </el-table-column>
        <el-table-column label="领取方式" min-width="100px">
          <template slot-scope="{ row }">
            <div>{{ getAcquireMethodText(row.acquireMethod) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="优惠券金额" min-width="100px">
          <template slot-scope="{row}">
            <div>{{ row.requiredAmount }}元</div>
          </template>
        </el-table-column>
        <el-table-column label="购买所需金额" min-width="120px">
          <template slot-scope="{row}">
            <div>{{ row.purchaseRequiredAmount || 0 }}元</div>
          </template>
        </el-table-column>
        <el-table-column label="所需积分" min-width="100px">
          <template slot-scope="{row}">
            <div>{{ row.requiredPoints || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="延期所需积分" min-width="120px">
          <template slot-scope="{ row }">
            <div>{{ row.extendRequiredPoints || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="详情"
          min-width="100px"
        ></el-table-column>
        <el-table-column prop="validHours" label="有效时长" min-width="100px">
          <template slot-scope="{ row }">
            <div>{{ formatUsePeriod(row.validHours) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="useSceneDesc"
          label="使用场景"
          min-width="100px"
        ></el-table-column>
        <el-table-column label="延期场景" min-width="100px">
          <template slot-scope="{ row }">
            <div>{{ formatExtendScene(row.extendSceneDesc) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="extendHours" label="延期时长" min-width="100px">
          <template slot-scope="{ row }">
            <div>{{ formatUsePeriod(row.extendHours) }}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="$refs.operaCouponTemplateWindow.open('编辑', row)"
              icon="el-icon-edit"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="deleteById(row)"
              icon="el-icon-delete"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCouponTemplateWindow
      ref="operaCouponTemplateWindow"
      @success="handlePageChange"
    />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCouponTemplateWindow from '@/components/rentHouse/OperaCouponTemplateWindow'

export default {
  name: 'CouponTemplate',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCouponTemplateWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        couponName: null,
        delFlag: null,
        description: null,
        discountAmount: null,
        extendHours: null,
        extendScene: null,
        extendSceneDesc: null,
        id: null,
        minAmount: null,
        requiredAmount: null,
        useScene: null,
        useSceneDesc: null,
        validHours: null
      },
      tagLoading: false
    }
  },
  created () {
    this.config({
      module: '',
      api: '/rentHouse/couponTemplate',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    formatUsePeriod (hours) {
      if (!hours || hours <= 0) {
        return '无限期'
      }

      const days = Math.floor(hours / 24)
      const remainingHours = hours % 24

      if (days === 0) {
        return `${remainingHours}小时`
      } else if (remainingHours === 0) {
        return `${days}天`
      } else {
        return `${days}天${remainingHours}小时`
      }
    },
    formatExtendScene (extendSceneDesc) {
      // 如果是数组，转换为逗号分隔的字符串
      if (Array.isArray(extendSceneDesc)) {
        return (
          extendSceneDesc.filter((item) => item && item.trim()).join(', ') ||
          '-'
        )
      }
      // 如果是字符串，直接返回
      if (typeof extendSceneDesc === 'string' && extendSceneDesc.trim()) {
        return extendSceneDesc
      }
      // 其他情况返回 '-'
      return ''
    },
    getAcquireMethodText (method) {
      const map = {
        FREE: '免费领取',
        PURCHASE: '付费购',
        POINTS: '积分兑换'
      }
      return map[method] || method || '-'
    }
  }
}
</script>
<style scoped>
.el-select-dropdown__item {
  height: auto !important;
}
</style>
